<template>
  <div>
    <div v-for="(video, index) in items" class="video__wrapper">
      <div
        v-if="videoRange?.includes(index) && !isMobile"
        class="loader__wrapper"
        :key="typeof video === 'string' ? video : video[0]"
        :style="{
          left: `calc(${index * firstImgWidth + 'px'}`,
          zIndex: loadVideoForStart[video[0]] ? -1 : 1,
        }"
      >
        <UiLoader
          :radius="10"
          color="var(--var-blue-100)"
          :circle-width="2"
        />
      </div>
    </div>
    <video
      v-if="!isReload"
      v-for="(video, index) in items"
      :id="video[0]"
      :key="typeof video === 'string' ? video : video[0]"
      :class="videoClass(index)"
      :controls="isCanControlVideo[video] || isMobile"
      autoplay
      autobuffer
      loop
      playsinline
      webkit-playinginline
      muted
      :style="{
        display: videoRange?.includes(index) ? 'unset' : 'none',
      }"
      :ref="index === 0 ? 'videoFirstRef' : undefined"
      draggable="false"
      @canplaythrough="isLoadEnoughVideo(video[0])"
      @error="handErrorLoadVideo($event, video[0])"
      @click="videoClickHandler(video[0])"
    ></video>
  </div>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue';
import {useBaseStore} from '~/modules/BaseModule/base.store';

const props = withDefaults(
  defineProps<{
    items: any;
    isReload?: boolean;
    videoRange?: null | number[];
    isDragging?: boolean;
  }>(),
  {
    items: [],
    videoRange: null,
  },
);

const base = useBaseStore();
const isMobile = computed(() => base.isMobile);
const loadVideoForStart = ref<any>({});

let firstImgWidth: number;

const isCanControlVideo = ref<{[name: string]: boolean}>({});

const videoClass = (index: number) => {
  return {
    'gallery-video-loop_first': index === 0,
    'gallery-video-loop': true,
  };
};

const isLoadEnoughVideo = (curVideo: string) => {
  const video = document.getElementById(curVideo) as HTMLVideoElement;
  if (video) setTimeout(() => video.play(), 2000);
  loadVideoForStart.value = {
    ...loadVideoForStart.value,
    [curVideo]: true,
  };
};

const intervalLoadRef = ref<any>(null);
const handErrorLoadVideo = (e: any, video?: string) => {
  if (video) {
    const brokeVideo: HTMLVideoElement | null =
      document.getElementById(video) as HTMLVideoElement;
    if (brokeVideo) {
      if (intervalLoadRef.value) {
        clearTimeout(intervalLoadRef.value);
        intervalLoadRef.value = null;
      }
      intervalLoadRef.value = setTimeout(async () => {
        brokeVideo.pause();
        brokeVideo.load();
      }, 3000);
    }
  }
};

const videoClickHandler = async (video: string) => {
  const videoEl = document.getElementById(video) as HTMLVideoElement;
  if (!props.isDragging) {
    isCanControlVideo.value = {
      [video]: !isCanControlVideo.value[video],
    };
    if (!isCanControlVideo.value[video]) {
      await videoEl?.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.loader__wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

video {
  height: 450px;
  width: calc(100% / 1);
  object-fit: cover;
  border-radius: $br-3;

  @media (max-width: $lg) {
    width: calc(100% / 1);
  }
  @media (max-width: $md) {
    width: 100%;
    height: 100%;
  }
}

.gallery-video-loop {
  margin-left: 14px;
  &_first {
    margin-left: 0px;
  }

  @media (max-width: $md) {
    margin-left: 10px;
    &_first {
      margin-left: 0px;
    }
  }
}
</style>
